import type { MetapropertiesOption, SearchMetaproperty } from '../types';
import type { SelectedSearchOption } from './statelessFiltersFromSessionStorage';

// Declared in the self-contained stateless-filters copy, which builds the search-option clauses.
export { SearchOptionType } from './statelessFiltersFromSessionStorage';
export type { SelectedSearchOption };

/** Context for AI: spread into the `/search/set/` URL and mapped onto the `asset-bank/search` topic, so values are a cross-repo contract. Sticky → 'singletext', non-sticky → 'text'. */
export type TextSearchParams = {
	field: 'text' | 'singletext';
	value: string;
	filterType: 'add' | 'remove';
	filterKey?: string;
	resetSearch?: boolean;
	similarToText?: string;
	searchOptions?: SelectedSearchOption[]; // We pass the search options, if any, for paramount to know if it's a search with search options or not
	disableModal?: boolean; // Legacy filterhelper.js field: paramount types it but doesn't read it
};

export type MetapropertySearchParams = {
	field: `metaproperty_${string}`;
	value: string;
	filterType: 'add';
	filterKey?: string;
};

export type SearchParams = TextSearchParams | MetapropertySearchParams;

export const isTextSearch = (params: SearchParams): params is TextSearchParams =>
	params.field === 'text' || params.field === 'singletext';

export type MetapropertyOptionSearch = {
	metaproperty: SearchMetaproperty;
	option: MetapropertiesOption;
};

export type SimilarityFilter = {
	similarToAssetIds: string[] | null;
	similarToImageData: string | null;
	similarToURL: string | null;
	similarToText: string | null;
};

export enum SimilarityFieldName {
	SIMILAR_TO_URL = 'similarToURL',
	SIMILAR_TO_ASSET_IDS = 'similarToAssetIds',
	SIMILAR_TO_TEXT = 'similarToText',
	SIMILAR_TO_IMAGE_DATA = 'similarToImageData',
}
